/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_ReplyInputs */



/**
* | output |
* | --- |
* | "Reply and approval" |
*
* @param {Event_Group_Sync_Property_ReplyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_reply = /** @type {((inputs?: Event_Group_Sync_Property_ReplyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_ReplyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reply and approval")
	if (locale === "de") return /** @type {LocalizedString} */ ("Reply and approval")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reply and approval")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Reply and approval")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reply and approval")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Reply and approval")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Reply and approval")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Reply and approval")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reply and approval")
	return /** @type {LocalizedString} */ ("Reply and approval")
});